import React, { useState, Fragment, useEffect } from "react";
import {
  camelCase,
  DIMENSION_TYPES,
  PARCEL_TYPES,
  sentenceCase,
  WEIGHT_TYPES,
} from "../../../../constants";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import {
  OrderRejectModal,
  OrderShipModal,
} from "../../../common/Modals";
import { formatNum } from "../../../../oscar-pos-core/constants";
import {
  AppCheckbox,
  ParagraphText,
  UBButton,
} from "../../../../Libraries";
import { toast } from "react-toastify";
import {
  PATCH_ACCEPT_REJECT_ORDER,
  GET_ORDER_DETAILS_BY_ID,
} from "../../../../apis/configuration";
import Icon from "../../../../assets/Icon";
import { Box, CircularProgress } from "@mui/material";
import AppTooltip from "../../../common/Apptooltip";
import styles from "./styles.module.css";
import ConfirmationModal from "../../../common/Modals/ConfirmationModal";
import { dateFormatInNumberWithSpace, getInitials } from "../../../../utils";
const OrderListItem = ({ data }) => {
  const {
    handleOrderStatus,
    handleGetOrder,
    rejectReasons,
    updateLoad,
    handleSelection,
    orderToDownload,
    order,
    toggleChatWidget,
    index,
    statusColor,
    clearMarkedOrders,
    I18n,
    handleOrderStatusList
  } = data || {};
  const {
    payment_method,
    customer_name,
    order_status,
    order_number,
    grand_total,
    order_date,
    id,
    tracking_id,
    schedule_status,
  } = order || {};

  const [rejectReason, setRejectReason] = useState({ other: "", reason: "" });
  const [toggle, setToggle] = useState({ type: "", toggle: false });
  const [rejectModal, setRejectModal] = useState(false);
  const [shipModal, setShipModal] = useState(false);
  const [shipParcel, setShipParcel] = useState({
    parcel_type: "",
    weight: { value: "", unit: "Kg" },
    dimensions: { unit: "Inch" },
  });
  const [disabled, setDisabled] = useState(false);
  const isValidationForm = (item) => {
    return item.parcel_type === "Flyer"
      ? +item.weight.value && item.weight.unit
      : item.parcel_type === "Carton"
        ? +item.weight.value &&
        item.weight.unit &&
        +item.dimensions.length &&
        +item.dimensions.width &&
        +item.dimensions.height &&
        item.dimensions.unit
        : false;
  };
  /**
   * Receive type to accpet, reject and view order
   * @returns calling functions based on type;
   */
  const handleAction = (e, type) => {
    e.stopPropagation();

    if (type == "switch") handleSelection({ id, tracking_id, order_status });
    else if (type == "view") {
      triggerLogEvent(analytics, "sc_order_item_click", { order_number, order_status });
      handleGetOrder(GET_ORDER_DETAILS_BY_ID, { id });
    }
    else if (type == "ready_to_ship") {
      triggerLogEvent(analytics, "sc_order_item_click", { order_number, action: "ready_to_ship" });
      toggleShipModal(true);
    }
    else if (type == "schedule_error") toggleChatWidget();
    else if (type == "schedule_success") {
    } else {
      triggerLogEvent(analytics, "sc_order_item_click", { order_number, action: type });
      toggleOrderModal(type, true);
    }
  };

  /**
   * Receive params of type to handle acccept or reject order and toogle to toggle mdoal
   * @returns toggle modal based on type;
   */
  const toggleOrderModal = (type = "", toggle = false) =>
    setToggle({ type, toggle });

  /**
   * Receive toggle to toggle reject order modal
   * @returns toggle modal;
   */
  const toggleRejectModal = (toggle = false) => setRejectModal(toggle);

  /**
   * Receive toggle to toggle ship order modal
   * @returns toggle modal;
   */
  const toggleShipModal = () => setShipModal(!shipModal);

  /**
   * Receive key to change specific field value by params (value)
   * @returns update specific state;
   */

  const onChangeText = (key, value) => {
    if (key == I18n.enter_reason_here)
      setRejectReason({ ...rejectReason, other: value });
    else if (key == I18n.select_reason)
      setRejectReason({ reason: value.reason });
    else if (key == I18n.select_parcel_type)
      setShipParcel((e) => {
        setDisabled(isValidationForm({ ...e, parcel_type: value }));
        resetShipParcel(value);
        return { ...e, parcel_type: value };
      });
    else if (key == I18n.weight_type)
      setShipParcel((e) => {
        setDisabled(
          isValidationForm({ ...e, weight: { ...e.weight, unit: value } }),
        );
        return { ...e, weight: { ...e.weight, unit: value } };
      });
    else if (key == I18n.enter_weight)
      setShipParcel((e) => {
        if (value < 0) return { ...e };
        setDisabled(isValidationForm({ ...e, weight: { ...e.weight, value } }));
        return { ...e, weight: { ...e.weight, value: value ? +value : "" } };
      });
    else if (key == I18n.select_dimensions)
      setShipParcel((e) => {
        const [length, width, height] = value ? value.split(" x ") : [];
        setDisabled(
          isValidationForm({
            ...e,
            dimensions: {
              ...e.dimensions,
              length: +length,
              width: +width,
              height: +height,
            },
          }),
        );
        return {
          ...e,
          dimensions: {
            ...e.dimensions,
            length: +length,
            width: +width,
            height: +height,
          },
        };
      });
  };

  const resetShipParcel = (parcel_type) => {
    setShipParcel({
      parcel_type: parcel_type,
      weight: { value: "", unit: "Kg" },
      dimensions: { unit: "Inch" },
    });
  };
  /**
   * Toggle reject modal or calling api to accept order
   * @returns toggle modal and update order
   */
  const handleOrder = () => {
    if (toggle.type == "reject") {
      toggleRejectModal(true);
      toggleOrderModal();
    } else {
      let params = { id };

      if (toggle.type == "accept") params["accept"] = true;
      else {
        params["ready_to_ship"] = true;
        params["parcel_type"] = PARCEL_TYPES[shipParcel.parcel_type].type;
        if (shipParcel.parcel_type === "Carton") {
          let weight = { ...shipParcel.weight };
          let dimensions = { ...shipParcel.dimensions };
          weight.unit = WEIGHT_TYPES[weight.unit].type;
          dimensions.unit = DIMENSION_TYPES[dimensions.unit].type;
          params["weight"] = weight;
          params["dimensions"] = dimensions;
        } else {
          let weight = { ...shipParcel.weight };
          weight.unit = WEIGHT_TYPES[weight.unit].type;
          params["weight"] = weight;
        }
      }
      handleOrderStatus(PATCH_ACCEPT_REJECT_ORDER, params)
        .then(() => {
          toggleOrderModal();
          toggleShipModal();
          clearMarkedOrders();
          setShipParcel({
            parcel_type: "",
            weight: { value: "", unit: "Kg" },
            dimensions: { unit: "Inch" },
          });
          toast.success(
            toggle.type == "accept"
              ? "Order accepted successfully"
              : "Order has been marked as ready to shipped",
            { className: "successToast" },
          );
        })
    }
  };

  /**
   * calling api to reject order
   * @returns update order
   */
  const handleRejectOrder = () =>
    handleOrderStatus(PATCH_ACCEPT_REJECT_ORDER, {
      id,
      reject: true,
      reason: rejectReason.other || rejectReason.reason,
    }).then(() => {
      toggleRejectModal();
      clearMarkedOrders();
      toast.success("Order rejected successfully", {
        className: "successToast",
      });
    });


  useEffect(() => {
    const pollInterval = 5000; // Adjust the polling interval in milliseconds (5 seconds in this example)
    let isCall = order_status == "ready_to_ship" && schedule_status == "pending";
    const pollApi = setInterval(() => {
      if (isCall) {
        let params = { order_ids: `${id}` };
        handleOrderStatusList(params);
      } else {
        clearInterval(pollApi);
      }
    }, pollInterval);
    // Cleanup: clear the interval when the component unmounts
    return () => clearInterval(pollApi);
  }, [order_status, schedule_status]);


  return (
    <>
      <Box
        id={`saddar_order_list_${index}`}
        className={`invoiceListTableBody AccountItemListWrapper ${styles.OrderTableHeader}`}
        onClick={(e) => {
          e?.preventDefault();
          handleAction(e, "view")
        }}
      >
        <Box
          className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textLeft sidebarOption ${styles.headerContainer}`}
        >
          <ParagraphText className="fontSize14 fontWeight400 textLeft newFontColor">
            <div className="checkboxCol" onClick={(e) => e.stopPropagation()}>
              <AppCheckbox
                disabled={false}
                label={<p className="marBot0 fontSize14"></p>}
                onClick={(e) => {
                  handleAction(e, "switch");
                }}
                checked={orderToDownload[id]}
              />
            </div>
            {dateFormatInNumberWithSpace(order_date)}
          </ParagraphText>
        </Box>

        <Box className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textLeft`}>
          <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor displayFlex">
            {order_number}
          </ParagraphText>
        </Box>

        <Box className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textLeft`}>
          <ParagraphText className={`fontSize14 fontWeight400 truncateOneLine textLeft ${statusColor[order_status]}`}>
            {camelCase(I18n[order_status])}
          </ParagraphText>
        </Box>

        <Box className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textLeft`}>
          <ParagraphText className={`fontSize14 textLeft newFontColor ${styles.selectedContactWrapper}`}>
            <Box className={`${styles.trigger} ${styles.triggerWithName}`}>

              <ParagraphText className={styles.avatar}>
                <span className={styles.avatarInitials}>
                  {getInitials(customer_name)}
                </span>
              </ParagraphText>
              <ParagraphText className={styles.contactName}>

                {camelCase(customer_name)}
              </ParagraphText>
            </Box>
          </ParagraphText>
        </Box>
        <Box className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textLeft`}>
          <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
            {I18n[payment_method] || camelCase(payment_method)}
          </ParagraphText>
        </Box>
        <Box className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} rightLeft`}>
          <ParagraphText className="fontSize14 fontWeight400 truncateOneLine rightLeft newFontColor amountColumnInnerWrapper">
            Rs. {formatNum(grand_total)}
          </ParagraphText>
        </Box>

        <Box
          className={`invListTableHeaderCol sevenColumn ${styles.OrderTableBox} textCenter`}
        >
          <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textCenter newFontColor">
            <div className={styles.OrderTableAction}>
              {order_status == "pending" ||
                order_status == "pending_on_customer" ? (
                <>
                  <UBButton
                    id="order_reject_btn"
                    className={`fontSize12 ubSecondaryButton textUppercase ${styles.actionBtn}`}
                    onClick={(e) => handleAction(e, "reject")}
                    title={I18n.reject}
                    loading={false}
                  />

                  {order_status == "pending_on_customer" ? null : (
                    <UBButton
                      id="order_accept_btn"
                      className={`fontSize12 ubPrimaryButton textUppercase ${styles.actionBtn}`}
                      onClick={(e) => handleAction(e, "accept")}
                      title={I18n.accept_small}
                      loading={false}
                    />
                  )}
                </>
              ) : order_status == "accepted" ? (
                <>
                  <UBButton
                    id="order_ship_btn"
                    className={`fontSize12 ubPrimaryButton textUppercase ${styles.actionBtn}`}
                    onClick={(e) => handleAction(e, "ready_to_ship")}
                    title={I18n.ready_to_ship}
                    loading={false}
                  />
                </>
              ) : order_status == "ready_to_ship" && schedule_status ? (
                schedule_status ==
                  "pending" ? (
                  <CircularProgress size={24} className={styles.loader} />
                ) : schedule_status == "error" ? (
                  <AppTooltip tooltip="Contact chatsupport" id="icon-tooltip">
                    <div className="">

                      <UBButton
                        id="order_contact_support_btn"
                        className={`fontSize12 ubSecondaryButton textUppercase ${styles.actionBtn}`}
                        onClick={(e) => handleAction(e, "schedule_error")}
                        title={"Contact Support"}
                        loading={false}
                      />
                    </div>
                  </AppTooltip>
                ) : (
                  <div className="">
                    <Icon
                      data={{
                        name: "tickIcon",
                        fill: "green",
                        height: "14px",
                        width: "14px",
                        viewBox: "0 0 16 16",
                        onClick: (e) => handleAction(e, "schedule_success"),
                      }}
                    />
                  </div>
                )
              ) : null}
            </div>
          </ParagraphText>
        </Box>
      </Box>

      <ConfirmationModal
        open={toggle.toggle}
        onClose={() => toggleOrderModal()}
        onConfirm={handleOrder}
        message={`${I18n.are_you_sure} ${toggle.type == "reject"
          ? I18n.you_want_to_reject_this_order
          : toggle.type == "accept"
            ? I18n.you_want_to_confirm_order
            : I18n.you_want_to_ship_this_order}`}
        title={sentenceCase(`${I18n.order_number} # ${order_number} ${I18n.confirmation}`)}
        confirmText={toggle.type == "reject"
          ? `${I18n.reject} ${I18n.order}`
          : toggle.type == "accept"
            ? `${I18n.accept} ${I18n.order}`
            : toggle.type == "ready_to_ship"
              ? I18n.ready_to_ship
              : ""}
        cancelText={I18n.back}
        id="order_modal"
        confirmButtonClassName="ubPrimaryButton"
      />
      <OrderRejectModal
        header={{ title: "please_share_ur_reason" }}
        body={{
          title: I18n.select_reason,
          toggle: rejectModal,
          toggleRejectModal,
          rejectReasons,
          onChangeText,
          rejectReason,
          I18n,
        }}
        footer={[
          {
            data: {

              className: "ubSecondaryButton",
              title: I18n.cancel,
              onClick: () => { triggerLogEvent(analytics, "sc_order_reject_cancel", { order_number }); toggleRejectModal(); },
              id: `rejected_cancel`,
            },
          },
          {
            data: {
              disabled: !(rejectReason.reason == "Other"
                ? rejectReason.other
                : rejectReason.reason),
              className: "ubPrimaryButton",
              title: I18n.save,
              onClick: () => { triggerLogEvent(analytics, "sc_order_reject_confirmed", { order_number }); handleRejectOrder(); },
              id: `rejected_confirm`,
            },
          },
        ]}
      />

      <OrderShipModal
        headerTitle={I18n.ready_to_ship}
        body={{
          title: I18n.select_parcel_type,
          toggle: shipModal,
          toggleShipModal,
          onChangeText,
          shipParcel,
        }}
        footer={[
          {
            data: {
              title: I18n.back,
              onClick: () => { triggerLogEvent(analytics, "sc_order_ship_cancel", { order_number }); toggleShipModal(); },
              className: "ubSecondaryButton",
              id: "ship_order_id",
            },
          },
          {
            data: {
              disabled: !Boolean(disabled),
              title: I18n.ship_order,
              onClick: () => { triggerLogEvent(analytics, "sc_order_ship_confirmed", { order_number }); handleOrder(); },
              className: "ubPrimaryButton",
              id: "ship_order_id",
            },
          },
        ]}
      />
    </>
  );
};

export default OrderListItem;
